import {createContext, useCallback, useContext, useRef, useState} from "react";

// Р7 — ЕДИН начин за потвърждение на изтриване в цялата платформа.
//
// Досега имаше два: диалог на браузъра (админ линкове, въпроси, отмяна на внос,
// декларации) и вграден втори ред „Изтриване на този запис?" (замени, изчертани
// площи, редовете в „Първоначални данни"). Два навика значат, че човек не знае
// какво ще последва, преди да натисне — а точно това е моментът, в който трябва
// да знае.
//
// Диалогът е СОБСТВЕН, а не `window.confirm`, по три причини: бутоните да пишат
// „Да, изтрий" и „Не" (браузърният казва OK/Cancel на своя си език), да носи
// подробност какво точно ще падне, и да не може да бъде заглушен от браузъра
// („не показвай повече диалози от тази страница").
//
// Употреба:
//     const confirm = useConfirm();
//     if (!await confirm({title: "…", message: "…"})) return;

const ConfirmContext = createContext();

const ПО_ПОДРАЗБИРАНЕ = {
    title: "Наистина ли да се изтрие?",
    message: "",
    detail: "",
    confirmText: "Да, изтрий",
    cancelText: "Не",
    // Т3: долният ред е сменяем. По подразбиране е за изтриване, но диалогът
    // вече се ползва и за добавяне (копирането с наслагване) — там „Действието
    // е необратимо" звучи като заплаха за данните, а нищо не се губи.
    note: "Действието е необратимо.",
};

export const ConfirmProvider = ({children}) => {
    const [state, setState] = useState(null);
    const resolveRef = useRef(null);

    const confirm = useCallback((options = {}) => {
        setState({...ПО_ПОДРАЗБИРАНЕ, ...options});
        return new Promise(resolve => {
            resolveRef.current = resolve;
        });
    }, []);

    const close = (отговор) => {
        setState(null);
        if (resolveRef.current) {
            resolveRef.current(отговор);
            resolveRef.current = null;
        }
    };

    return (
        <ConfirmContext.Provider value={confirm}>
            {children}
            {state && (
                <>
                    <div className="modal-backdrop show" style={{zIndex: 2050}}/>
                    <div className="modal d-block" style={{zIndex: 2060}}
                         role="dialog" aria-modal="true"
                         onKeyDown={(e) => e.key === "Escape" && close(false)}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content"
                                 style={{border: "1px solid var(--app-danger-fg)"}}>
                                <div className="modal-header">
                                    <h5 className="modal-title"
                                        style={{color: "var(--app-danger-fg)"}}>
                                        {state.title}
                                    </h5>
                                </div>
                                <div className="modal-body">
                                    {state.message && <p className="mb-2">{state.message}</p>}
                                    {state.detail && (
                                        <p className="mb-0 fw-bold">{state.detail}</p>
                                    )}
                                    {state.note && (
                                        <p className="mb-0 mt-2 text-muted"
                                           style={{fontSize: "0.9rem"}}>
                                            {state.note}
                                        </p>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    {/* „Не" е пръв и с фокус — при бързо натискане
                                        по-безопасният отговор е този, който излиза. */}
                                    <button type="button" className="btn btn-secondary"
                                            autoFocus onClick={() => close(false)}>
                                        {state.cancelText}
                                    </button>
                                    <button type="button" className="btn btn-danger"
                                            onClick={() => close(true)}>
                                        {state.confirmText}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </ConfirmContext.Provider>
    );
};

export const useConfirm = () => useContext(ConfirmContext);
